var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.04337C2 6.66046 2 6.46901 2.04935 6.2927C2.09307 6.13652 2.16491 5.98963 2.26135 5.85924C2.37022 5.71204 2.52135 5.5945 2.82359 5.35942L7.34513 1.84267C7.57935 1.6605 7.69646 1.56941 7.82577 1.5344C7.93987 1.50351 8.06013 1.50351 8.17423 1.5344C8.30354 1.56941 8.42065 1.6605 8.65487 1.84267L13.1764 5.35942C13.4787 5.5945 13.6298 5.71204 13.7386 5.85924C13.8351 5.98963 13.9069 6.13652 13.9506 6.2927C14 6.46901 14 6.66046 14 7.04337V11.8667C14 12.6134 14 12.9868 13.8547 13.272C13.7268 13.5229 13.5229 13.7268 13.272 13.8547C12.9868 14 12.6134 14 11.8667 14H4.13333C3.3866 14 3.01323 14 2.72801 13.8547C2.47713 13.7268 2.27316 13.5229 2.14532 13.272C2 12.9868 2 12.6134 2 11.8667V7.04337Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.b41a2465083ecf42045aa5bb4536681a.svg";
export { ForwardRef as ReactComponent };